export default __webpack_public_path__ + "static/engineering_challenges-c3e7084d652d265fa64e67857b841f1f.jpg";